import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";
import Button from "@shared/v2/Button";

const SuperUsersTable = ({ onEdit, onRemove, superUsers }) => {
  const handleOnRemove = (e, superUser) => {
    e.preventDefault();

    if (window.confirm("Are you sure?")) {
      onRemove(superUser.id);
    }
  };

  const dateFormat = "MM/DD/YYYY h:mm:ss a";

  const superUserTableRow = (superUser) => (
    <tr key={superUser.id}>
      <td>{superUser.id}</td>
      <td>{superUser.email}</td>
      <td>{superUser.role}</td>
      <td>{dayjs(superUser.created_at).format(dateFormat)}</td>
      <td>{dayjs(superUser.updated_at).format(dateFormat)}</td>
      <td>
        <Button onClick={() => onEdit(superUser)}>Edit</Button>
      </td>
      <td>
        <Button onClick={(e) => handleOnRemove(e, superUser)}>Remove</Button>
      </td>
    </tr>
  );

  return (
    <div className="tw-flex-1 tw-overflow-auto">
      <table className="table table-striped table-hover table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Role</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th aria-label="edit super user" />
            <th aria-label="remove super user" />
          </tr>
        </thead>
        <tbody>{superUsers.map(superUserTableRow)}</tbody>
      </table>
    </div>
  );
};

SuperUsersTable.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  superUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      email: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      created_at: PropTypes.string.isRequired,
      updated_at: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default SuperUsersTable;
